import { useLocale } from '@ecomm/data-hooks'
import { useScript } from '@ecomm/shared-hooks'
import { getSprChat } from '@ecomm/shared-window'
import { useCallback, useEffect } from 'react'
import { getLiveChatScriptUrl } from '../getLiveChatScriptUrl'

import { supportChatAppId } from '../chatAppId'
import { useLiveChatClientExists } from '../useLiveChatClientExists'

/**
 * A data-source-agnostic implementation of sending order confirmation event to LiveChat.
 *
 * Original implementation: https://github.com/simplisafe/ss-ecomm-frontend/blob/8eabf9965d3e2c7fb3762c7b6902d32ad2f62b90/apps/checkout/src/components/PaymentConfirmationContainerComponent/liveChatOrderTracking.ts
 */
export function useLiveChatTrackOrder(
  orderId: string,
  total: number,
  items: readonly string[]
) {
  const locale = useLocale()
  const currencyCode = locale === 'en-GB' ? 'GBP' : 'USD'

  const status = useScript(getLiveChatScriptUrl(supportChatAppId))
  const clientExists = useLiveChatClientExists(status)

  const trackOrder = useCallback(() => {
    getSprChat(chat => {
      chat('updateConversationContext', {
        context: {
          _c_62600286c8257b12f6ca54b9: [total],
          _c_626002a3c8257b12f6ca67ca: [currencyCode],
          _c_626002bdc8257b12f6ca77ee: [orderId],
          _c_626002d5c8257b12f6ca8713: items
        }
      })
    })
  }, [currencyCode, items, orderId, total])

  useEffect(() => {
    clientExists && trackOrder()
  }, [clientExists, trackOrder])
}
